module.exports = __webpack_public_path__ + "img/view-agencies.9b7764e8.jpg";